import Innerbannerlines from "@/../../public/images/inner-banner-lines.svg";
import Logoicon from "@/../../public/images/fav-icon.svg";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { MdOutlineWatchLater } from "react-icons/md";
import { useParams, Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { blogDetailsApi } from "../service/apis/bloglisting.api";
import Loader from "../common/Loader/loader";

const BlogDetailsScreen = () => {
  const { blogId } = useParams();

  const navigate = useNavigate();

  const [blogDetails, setBlogDetails] = useState<any>(null);
  const [recentPosts, setRecentPosts] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);

  const displayBlogDetails = async (blogIdd: any) => {
    setIsLoading(true);
    try {
      const response = await blogDetailsApi(blogIdd);
      //console.log(response.blog);
      setBlogDetails(response.blog);
      setRecentPosts(response.recentPosts);
    } catch (error) {
      console.error("Catch Error :", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    displayBlogDetails(blogId);
  }, [blogId]);

  const calculateTimeAgo = (date: string) => {
    const currentDate = new Date();
    const givenDate = new Date(date);
    const timeDifference = currentDate.getTime() - givenDate.getTime();
    const daysAgo = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    if (daysAgo === 0) {
      return "Today";
    } else if (daysAgo === 1) {
      return "1 day ago";
    } else {
      return `${daysAgo} days ago`;
    }
  };

  const decodeHtml = (html = "") => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  const sanitizeData = (htmldata = "") => {
    const sanitizedDescription = decodeHtml(htmldata);
    return (
      <div dangerouslySetInnerHTML={{ __html: sanitizedDescription }}></div>
    );
  };
  
  return (
    <>
      {/* <HeaderScreen /> */}
      {/* {!isLoading ? (
        <>
        <Loader />
        </>
      ) : ( */}
        <div className="front-pages">
          <section className="home-banner innerBanner position-relative common-padd-xl">
            <div className="homeLine">
              <img src={Innerbannerlines} alt="line icon" />
            </div>
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="innerBanner-info text-center">
                    <h1>{blogDetails?.title}</h1>
                    <div className="breadcrumb-holder text-center">
                      <Breadcrumb>
                        <Breadcrumb.Item onClick={(e) => {e.preventDefault();navigate("/")}} href="/">
                          <img src={Logoicon} alt="logo icon" /> Home
                        </Breadcrumb.Item>
                        <Breadcrumb.Item onClick={(e) => {e.preventDefault();navigate("/blog")}} href="/blog">
                          Blog
                        </Breadcrumb.Item>
                        <Breadcrumb.Item active>
                          {blogDetails?.title}
                        </Breadcrumb.Item>
                      </Breadcrumb>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {isLoading && (
            <Loader />            
          )}
          <section className="blogDetails-area position-relative common-padd-xl">
            <div className="container">
              <div className="row">
                <div className={recentPosts && recentPosts?.length > 0 ? "col-lg-9" : "col-lg-12"}>
                  <div className="blogDetails-holder">
                    <div className="blogDetailsImg">
                      <img
                        src={blogDetails?.featuredImage}
                        alt={blogDetails?.title}
                      />
                    </div>
                    <div className="blogDetailsInfo">
                      {blogDetails?.createdAt && <p className="dateofpost">
                        <span>
                          <MdOutlineWatchLater />
                        </span>{" "}
                        Posted {calculateTimeAgo(blogDetails?.createdAt)}
                      </p>}
                      
                      {/* <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi.</p>
                                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
                                            <h3>Why Should You Choose Us?</h3>
                                            <p>But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because those who do not know how to pursue pleasure.</p>
                                            <ul className="rightliarrow">
                                                <li>We make it quick, easy and convenient for scheduling to save time</li>
                                                <li>Our promise is to be respectful of you and your home as if it were our own</li>
                                                <li>We stand behind our work with a one-year guarantee on all labor</li>
                                            </ul>
                                            <div className="row">
                                                <div className="col-lg-6 blogdetailsimgsm"><img src={Bloglist7} alt="blog 7" /></div>
                                                <div className="col-lg-6 blogdetailsimgsm"><img src={Bloglist6} alt="blog 6" /></div>
                                            </div>
                                            <p>Itaque earum rerum hic tenetur a sapiente delectus, ut aut reiciendis voluptatibus maiores alias consequatur aut perferendis doloribus asperiores repellat. On the other hand, we denounce with righteous indignation and dislike men who are so beguiled and demoralized by the charms of pleasure of the moment, so blinded by desire, that they cannot foresee the pain and trouble that are bound to ensue.</p> */}
                      {sanitizeData(blogDetails?.content)}
                    </div>
                  </div>
                </div>
                {recentPosts && recentPosts?.length > 0 && (
                <div className="col-lg-3">
                  <h3>Recent Posts</h3>
                  {/* {recentPosts && recentPosts?.length > 0 && ( */}
                    <div className="recentblog-holder">
                      <ul>
                        {recentPosts &&
                          recentPosts.map((resp: any, index: number) => (
                            <li key={index}>
                              <div className="blogImg">
                                <Link to={`/blog-details/${resp?.slug}`}>
                                  <img
                                    src={resp?.featuredImage}
                                    alt={resp?.title}
                                  />
                                </Link>
                              </div>
                              <div className="blogInfo">
                                <h4>
                                  {/* <a href="#">{resp?.title}</a> */}
                                  <Link to={`/blog-details/${resp?.slug}`}>
                                    {resp?.title}
                                  </Link>
                                </h4>
                              </div>
                            </li>
                          ))}
                      </ul>
                    </div>
                  {/* ) ( <p>No Recent Posts available</p> )} */}
                </div>)}
              </div>
            </div>
          </section>
        </div>
      {/* )
      } */}

      {/* <FooterScreen /> */}
    </>
  );
};
export default BlogDetailsScreen;
